(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/shared-components/input/country-dropdown.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/shared-components/input/country-dropdown.js');
"use strict";


const {
  Select,
  Option,
  ControlGroup,
  FormContext
} = svs.ui.ReactForm;
const {
  COUNTRYID
} = svs.ticket_partner.sharedComponents.input.constants.names;
const {
  countries
} = svs.ticket_partner.sharedComponents.input.constants;
const CountryDropdown = _ref => {
  let {
    handleDropDownChange,
    state,
    disabled = false,
    name = null,
    isLessSpace = false
  } = _ref;
  const validate = val => {
    let errorMessage = '';
    let isValid;
    if (!val) {
      isValid = false;
      errorMessage = 'Du måste välja ett land';
    } else {
      isValid = true;
    }
    return {
      errorMessage,
      isValid,
      name
    };
  };
  return React.createElement(FormContext.Consumer, null, _ref2 => {
    var _state$COUNTRYID, _state$COUNTRYID2;
    let {
      register
    } = _ref2;
    return React.createElement(ControlGroup, {
      isLessSpace: isLessSpace,
      v2: true
    }, React.createElement(Select, {
      disabled: disabled,
      id: COUNTRYID,
      name: name || COUNTRYID,
      onChange: handleDropDownChange,
      v2: true,
      value: ((_state$COUNTRYID = state[COUNTRYID]) === null || _state$COUNTRYID === void 0 ? void 0 : _state$COUNTRYID.toString()) || ''
    }, countries.map(_ref3 => {
      let {
        name,
        id
      } = _ref3;
      return React.createElement(Option, {
        key: id,
        value: id.toString()
      }, name);
    })), React.createElement("input", {
      hidden: true,
      readOnly: true,
      ref: register(name, validate),
      value: ((_state$COUNTRYID2 = state[COUNTRYID]) === null || _state$COUNTRYID2 === void 0 ? void 0 : _state$COUNTRYID2.toString()) || ''
    }));
  });
};
svs.ticket_partner.sharedComponents.input.CountryDropdown = CountryDropdown;

 })(window);